import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './MoveSubject.module.scss';

/**
 * Import components
 */

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class MoveSubject extends Component {

    constructor() {
        super();

        this.state = {
        };
    }

    render() {

    
        return (
            <div styleName='move-wrapper'>
                <p style={{ fontWeight: '800' }}>Je bent van plan een herhalend {this.props.agendaInsteadOfSubject ? 'agenda item' : 'vak'} te {this.props.changeInsteadOfMove ? 'wijzigen' : 'verplaatsen'}</p>
                <p>Wil je dit {this.props.agendaInsteadOfSubject ? 'agenda item' : 'vak'}  overal {this.props.changeInsteadOfMove ? 'wijzigen' : 'verplaatsen'} of alleen op de geselecteerde plaats?</p>
                { !this.props.agendaInsteadOfSubject && 
                    <p>Let op, de nog niet afgeronde huiswerktaken worden teruggeplaatst op de takenstapel.</p>
                }
                <div styleName='bottom-text'>
                    <p onClick={this.props.onClose}>Annuleren</p>
                    <p onClick={() => this.props.moveSubject('future')} styleName='red'>{this.props.changeInsteadOfMove ? 'Wijzig' : 'Verplaats'} vanaf hier overal</p>
                    <p onClick={() => this.props.moveSubject('single')} styleName='red'>{this.props.changeInsteadOfMove ? 'Wijzig' : 'Verplaats'} alleen op deze plaats</p>
                </div>
            </div>
        );
    }
}

export default MoveSubject;
